import { React } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import ZoneSubscribeColumn from './ZoneSubscribeColumn';
import ZoneSubscribeInfo from './ZoneSubscribeInfo';

export default function ZoneSubscribeBox(props) {
  const { subscribeList } = props;
  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  return (
    <TopLevelWrapper>
      <TitleWrapper>
        <TitleBox backgroundColor={theme.class5}>
          <Text fontFamily='NotoSansKR-Bold' fontSize={14} color={theme.subBackground} hover='default'>{t('myStoreSetting.subscribe.title')}</Text>
        </TitleBox>
      </TitleWrapper>
      <LayerWrapper>
        <ZoneSubscribeColumn/>
        {
          subscribeList.map((data, index) => (
            <ZoneSubscribeInfo key={index} data={data}/>
          ))
        }
      </LayerWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;

  margin-top: 30px;
  padding-bottom: 343px;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  width: 100%;
`;

const TitleBox = styled.p`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 2px 20px;
  margin: 0 0 0 0;

  border-top-left-radius: 5px;
  border-top-right-radius: 5px;

  background-color: ${props => props.backgroundColor};
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: flex-start;
  align-items: flex-start;
  
  padding: 14px 0px;

  // width: 1191px;
  width: 100%;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: flex-start;
  align-items: flex-start;
  
  margin-left: 28px;
  
  gap: 4px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;
  
  margin: 0 0 0 0;
  
  color: ${props => props.color};
  
  &:hover {
    cursor: default;
  }
`;